import { observer } from 'mobx-react';
import * as React from 'react';
import FreebusyStore from '../../../../../FreebusyStore';
import ScheduleButtonView from './ScheduleButtonView';

interface Props {
  freebusyStore: FreebusyStore;
}

// The Freebusy SDK binds to this button by its id, so the id must not change.
class Button extends React.Component<Props, {}> {
  componentDidMount() {
    this.props.freebusyStore.loading();
  }

  render() {
    return (
      <ScheduleButtonView
        buttonId="freebusy-leadership-coaching-button"
        disabled={this.props.freebusyStore.schedulingDisabled}
        onClick={() => {}}
      />
    );
  }
}

export default observer(Button);
